import { render, staticRenderFns } from "./Page-PointRecords.vue?vue&type=template&id=2a0bd766&"
import script from "./Page-PointRecords.vue?vue&type=script&lang=js&"
export * from "./Page-PointRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports